import React from 'react';
import { useTranslation } from 'react-i18next';
import useScrollReveal from '../../hooks/useScrollReveal';

const ArtistPreview = ({ onLearnMore }) => {
  const [ref, isVisible] = useScrollReveal();
  const { t } = useTranslation();

  return (
    <section ref={ref} className="py-24 bg-[#FAF7F2]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          {/* Image */}
          <div
            className={`lg:w-1/2 reveal ${isVisible ? 'visible' : ''}`}
          >
            <div className="relative">
              {/* Main Image */}
              <div className="relative z-10 overflow-hidden">
                <img
                  src="/pics/IVP.png"
                  alt={t('artistPreview.name')}
                  className="w-full max-w-md mx-auto"
                />
              </div>

              {/* Decorative Elements */}
              <div className="absolute -bottom-6 -right-6 w-48 h-48 border border-[#B8963E]/30 -z-0" />
              <div className="absolute -top-6 -left-6 w-32 h-32 bg-[#B8963E]/10 -z-0" />
            </div>
          </div>

          {/* Content */}
          <div
            className={`lg:w-1/2 reveal reveal-delay-2 ${isVisible ? 'visible' : ''}`}
          >
            <span className="text-sm text-[#B8963E] tracking-widest uppercase mb-4 block">
              {t('artistPreview.label')}
            </span>

            <h2 className="text-4xl md:text-5xl mb-6 text-[#3D3831]">
              {t('artistPreview.name')}
            </h2>

            <div className="divider-elegant mb-8 mx-0" />

            <div className="space-y-4 text-[#5A5249] leading-relaxed mb-8">
              <p>{t('artistPreview.bio1')}</p>
              <p>{t('artistPreview.bio2')}</p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 mb-8">
              <div className="text-center lg:text-left">
                <div className="text-3xl text-[#B8963E] font-light mb-1">35+</div>
                <div className="text-xs text-[#8B7E6A] uppercase tracking-wider">
                  {t('artistPreview.yearsOfCreativity')}
                </div>
              </div>
              <div className="text-center lg:text-left">
                <div className="text-3xl text-[#B8963E] font-light mb-1">200+</div>
                <div className="text-xs text-[#8B7E6A] uppercase tracking-wider">
                  {t('artistPreview.worksCreated')}
                </div>
              </div>
              <div className="text-center lg:text-left">
                <div className="text-3xl text-[#B8963E] font-light mb-1">50+</div>
                <div className="text-xs text-[#8B7E6A] uppercase tracking-wider">
                  {t('artistPreview.exhibitions')}
                </div>
              </div>
            </div>

            <button onClick={onLearnMore} className="btn-outline">
              {t('artistPreview.learnMore')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ArtistPreview;
